export default {
    header: {
        application: '体验申请',
        feedback: '社区反馈',
        center: '帮助中心',
        login: '登录',
        register: '注册',
        logout: '退出登录',
        defaultName: '未登录',
        personal: '个人中心',
        manage: '后台管理',
        logOutTitle: '提示',
        logOutMessage: '此操作将退出登录，是否继续？',
        logOutConfirm: '确定',
        logOutCancel: '取消',
    },
    router: {
        home: '首页',
        aisearch:"AI搜索",
        center:'智能体中心',
        chat: '对话',
        file: '知识库',
        uie: '知识抽取',
        publick:'和YAYI{name}的对话',
        globalTitle: 'YAYI雅意',
        backendManage: '后台管理',
        YAYIFile: 'YAYIFile',
        knowledgeManage: '知识库管理',
        thumbsManage: '赞踩管理',
        QAndA: '问答记录',
        profile: '个人中心',
        accountOverview: '账户总览',
        rechargeManagement: '充值管理',
        accountRecharge: '账户充值',
        rechargeDetails: '充值明细',
        expenseDetails: '消费明细',
        callStatistics: '调用统计',
        accountSettings: '账户设置',
        login: '登录',
        trialApplication: '试用申请',
        ServiceAgreement: '服务协议',
        privacyPolicy: '隐私政策',
        uieDetail: 'UIE详情',
        share:"分享",
    },
    fontSize: {
        small: '字号-小',
        default: '字号-中',
        large: '字号-大',
        text:"文字大小"
    },
    model: {
        title: '抢先体验',
        describe: 'YAYI 2.0效果全面升级，AI工作助手更好的提高你的工作效率',
        describe2: '每日限量体验',
        unit: '次',
        intelligenTitle: '高级联网搜索',
        test:'Beta',
        // intelligenDescribe: 'YAYI 2.5预置了所有插件服务（CV理解、长文、文档解析、天气、计算器、联网、闻海），模型会基于问题判断自动调取插件并回答问题。',
        intelligenDescribe: '深度剖析问题，将复杂问题拆解为相互关联的子问题，确保每个问题具有明确的指向性。通过深度检索，搜集权威的信源资料，快速分析并总结的智能助手。',
    },
    tips:{
        title:'雅意YAYI-2024/6/13版本',
        add:'重点更新内容',
        tips1:'YAYI 2.5-高级联网问答',
        info1:'对用户提出的复杂问题，将拆解为多个相互关联的子问题，通过深度检索，搜集权威的信源资料，并快速分析总结。',
        tips2:'智能体-应用配置升级',
        info2:'新增智慧搜索专家，并基于用户使用习惯，支持按全部、热门、我的切换智能体。',
        tips3:'指令应用-引用便捷高效',
        info3:'优化指令的使用路径，置于输入框上方；用户只需输入“/+关键词”，即可快速搜索指令。',
        tips4:'长文档问答',
        info4:'支持添加多个文档、多个URL，支持基于文档多轮对话。',
        btn:"立即体验",
        modelTipsTitle:'YAYI 2.5 功能上线啦～',
        tip1:'1.点击上方切换功能',
        tip2:' 2.YAYI 2.5 支持高级联网搜索',
        infoMessage:'该模型暂不支持URL解析，请使用雅意',
        infoMessage1:'URL数量已达到上线',
        infoMessage2:'暂不支持该标签',
        ignore:"忽略此版本"

    }
}